import { render, staticRenderFns } from "./NotesLibraryWidget.vue?vue&type=template&id=62fbdbfc&scoped=true"
import script from "./NotesLibraryWidget.vue?vue&type=script&lang=js"
export * from "./NotesLibraryWidget.vue?vue&type=script&lang=js"
import style0 from "./NotesLibraryWidget.vue?vue&type=style&index=0&id=62fbdbfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fbdbfc",
  null
  
)

export default component.exports